import { useGameProviderBySlug } from '@/api/game-providers';
import { ErrorChip } from '@starsoft/common/components';
import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import { NavigationBreadcrumbs } from '@starsoft/common/components';
import { useRouter } from 'next/router';

export default function GamesByProviderBreadcrumbs() {
  const { t } = useTranslation('common');
  const { query } = useRouter();
  const slug: string | undefined = query.slug as string;
  const { gameProvider, isLoading, error, refetch } = useGameProviderBySlug({
    slug,
  });

  if (error) {
    return <ErrorChip action={refetch} />;
  }

  if (isLoading) {
    return <div className={styles.skeleton} />;
  }

  return (
    <NavigationBreadcrumbs
      to="/games/providers"
      lastPageLabel={t('providers')}
      currentPageLabel={gameProvider?.name as string}
    />
  );
}
